import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface Role {
  id: string;
  emoji: string;
}

interface RoleSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  isFilter?: boolean;
}

export const roles: Role[] = [
  { id: 'admin', emoji: '👑' },
  { id: 'reviewer', emoji: '👀' },
  { id: 'writer', emoji: '✍️' }
];

const filterRole: Role = {
  id: 'all',
  emoji: '👥'
};

export const RoleSelect: React.FC<RoleSelectProps> = ({
  value,
  onChange,
  className = '',
  isFilter = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  
  const availableRoles = isFilter ? [filterRole, ...roles] : roles;
  const selectedRole = availableRoles.find(role => role.id === value) || availableRoles[0];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`inline-flex items-center justify-between w-full px-4 py-2 text-sm bg-white border border-gray-300 rounded-lg hover:bg-gray-50 ${className}`}
      >
        <span className="flex items-center gap-2">
          <span>{selectedRole.emoji}</span>
          <span className="text-gray-700">{t(`teamMembers.roles.${selectedRole.id}`)}</span>
        </span>
        <ChevronDown className="w-4 h-4 ml-2 text-gray-400" />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 z-20 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
            <div className="py-1">
              {availableRoles.map(role => (
                <button
                  key={role.id}
                  onClick={() => {
                    onChange(role.id);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 text-sm ${
                    role.id === value
                      ? 'bg-primary-50 text-primary-600'
                      : 'text-gray-700 hover:text-primary-600'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <span className="text-lg">{role.emoji}</span>
                    <div>
                      <div className="font-medium">{t(`teamMembers.roles.${role.id}`)}</div>
                      <div className="text-xs text-gray-500">
                        {t(`teamMembers.roles.descriptions.${role.id}`)}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};